module.exports = __webpack_public_path__ + "static/media/aero6.5133e303.jpg";